import React from 'react';
import type { FC, ReactNode } from 'react';
import { Transform } from 'ink';
import terminalLink from 'terminal-link';
import { Text } from './Text.js';
import type { TextSkin } from './Text.js';

export interface LinkProps {
  skin?: TextSkin;
  url: string;
  children?: ReactNode;
}

export const Link: FC<LinkProps> = ({ skin, children, url }) => {
  if (children) {
    if (terminalLink.isSupported) {
      return (
        <Transform
          transform={(childrenAsString) =>
            terminalLink(childrenAsString, url, { fallback: false })
          }
        >
          <Text skin={skin} underline>
            {children}
          </Text>
        </Transform>
      );
    }

    return (
      <Text>
        <Text skin={skin} underline>
          {children}
        </Text>{' '}
        ({url})
      </Text>
    );
  }

  return (
    <Text skin="info" underline>
      {url}
    </Text>
  );
};
